function whenJQueryReady(callback) {
  if (window.jQuery) {
    callback();
    return;
  }
  const interval = setInterval(() => {
    if (window.jQuery) {
      clearInterval(interval);
      callback();
    }
  }, 50);
}

function initStoreLocator() {
  const storeLocatorConfig = window.storeLocatorConfig || {};

  if (!storeLocatorConfig.dataUrl) {
    console.error('Store locator: falta dataUrl en storeLocatorConfig.');
    return;
  }

  fetch(storeLocatorConfig.dataUrl)
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      whenJQueryReady(() => {
        new storeLocator('.map-container', '.location-options-container', data, storeLocatorConfig);
      });
    })
    .catch(error => {
      console.error('Store locator: error al cargar storesInfo.json', error);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStoreLocator);
} else {
  initStoreLocator();
}

class storeLocator {
    constructor(mapContainerSelector, locationOptionsContainer, storesInfo, config = {}) {
        this.$locationOptionsContainer = document.querySelector(locationOptionsContainer);
        this.$mapContainer = document.querySelector(mapContainerSelector);
        this.googleApiKey = config.googleApiKey || '';
        this.lat_act = 0;
        this.lon_act = 0;
        this.activePosition = false;
        this.counter = 0;
        this.markers = [];
        this.a_counter = 0;
        this.infowindow = {};
        this.storesInfo = storesInfo;
        this.icon = config.pinIcon || '';
        this.defaultCountry = config.defaultCountry || 'Cundinamarca';
        this.labelDepartment = config.labelDepartment || 'Departamento';
        this.labelCity = config.labelCity || 'Ciudad';
        this.defaultLat = parseFloat(config.defaultLat) || 4.6679668;
        this.defaultLng = parseFloat(config.defaultLng) || -74.0528827;

        if (!this.$locationOptionsContainer || !this.$mapContainer) {
            console.error('Store locator: no se encontraron contenedores del mapa o los filtros.');
            return;
        }

        this.initUI();
        this.storeInMap();

        if (!this.googleApiKey) {
            console.error('Store locator: configura la clave API de Google Maps en la sección.');
            return;
        }

        this.loadApiGoogle(() => {
            this.startLocator();
        });
    }

    initUI() {
        this.storesMapData = this.storesInfo;

        const divCountry = document.createElement('div');
        divCountry.id = 'container_country';

        const divCities = document.createElement('div');
        divCities.id = 'container_city';

        this.$locationOptionsContainer.appendChild(divCountry);
        this.$locationOptionsContainer.appendChild(divCities);
    }

    startLocator() {
        this.loadList();
        this.showDefaultView();

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => this.showPosition(position),
                () => this.showDefaultView()
            );
        }
    }

    showDefaultView() {
        if (this.activePosition) {
            return;
        }

        const $countries = window.jQuery('#countries');
        if ($countries.length) {
            $countries
                .val($countries.find(`option[country="${this.defaultCountry}"]`).val())
                .trigger('change');
        } else {
            this.detectedStoresPaint(this.defaultCountry, '');
        }
    }

    loadApiGoogle( $callback ){
        if (!this.googleApiKey) {
            return;
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
  
        if (script.readyState) {
            script.onreadystatechange = function() {
                if (script.readyState == "loaded" || script.readyState == "complete") {
                    script.onreadystatechange = null;
                    $callback();
                }
            };
        } else {
            script.onload = function() {
                $callback();
            };
        }
        script.src = `https://maps.googleapis.com/maps/api/js?libraries=places&key=${this.googleApiKey}`;
        document.getElementsByTagName("head")[0].appendChild(script);

    }//loadApiGoogle

    //Creates the map and all its options
    createMap( $options ){
        const mapholder = this.$mapContainer
            // mapholder.style.height = '600px';
            // mapholder.style.width = '62%';
        const map = new google.maps.Map( this.$mapContainer , $options);
        return map;
    }

    showPosition( $position ){
        this.activePosition = true;
    
        lat = $position.coords.latitude;
        lon = $position.coords.longitude;

        this.lat_act = lat;
        this.lon_act = lon;
        
        latlon = new google.maps.LatLng(lat, lon);
  
        const self = this;
        this.validateCountry(function($data) {
            const mapOptions = {
                center: latlon,
                zoom: 12,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                mapTypeControl: false,
                navigationControlOptions: { style: google.maps.NavigationControlStyle.SMALL }
            };
            const map = self.createMap(mapOptions);
            new google.maps.Marker({ position: latlon, map: map, title: "Store Locator Marker", animation: google.maps.Animation.DROP });
            self.painstStores(map, $data, function() {
                self.addMarker(map);
            });
        });
    }//showPosition

    //add the locations to map
    painstStores( $map, $data, $callback, $centinela ){

        this.markers = [];

        for (var i = 0; i < $data.length; i++) {
            var store = $data[i];
            var marker = new google.maps.Marker({
                data_complete: store,
                position: { lat: store[2], lng: store[1] },
                map: $map,
                content: store[3],
                // icon: this.icon,
                title: store[0]
            });
            this.markers.push(marker);
        }

        var data = this.markers;
        var listHTML = '<ul>';

        for (var i = 0; i < data.length; i++) {
  
            listHTML += `<li class="store-list-item" data-index="${i}">
                            <p class="store-list-item__name">${data[i].content.name}</p>
                            <div class="store-list-item__body">
                            ${(data[i].content.address != null && $.trim(data[i].content.address) != "" ?
                            '<p class="store-list-item__row"><strong>Dirección:</strong> ' + data[i].content.address + '</p>' : '')}

                            ${(data[i].content.phone != null && $.trim(data[i].content.phone) != "" ?
                            '<p class="store-list-item__row"><strong>Teléfono:</strong> ' + data[i].content.phone + '</p>' : '')}

                            ${(data[i].content.schedules != null && $.trim(data[i].content.schedules) != "" ?
                            '<p class="store-list-item__row"><strong>Horario de atención:</strong> ' + data[i].content.schedules + '</p>' : '')}
                            
                            </div>
                        </li>`;
        }

        listHTML += '</ul>';

        document.getElementById("stores").innerHTML = listHTML;

        if ($callback != undefined) {
            $callback();
        }
    }//painstStores

    addMarker( $map ){
        //console.log('addMarker');
        const self = this;
        if (this.a_counter < this.markers.length) {
            var i = this.a_counter;
            var markers_alls = this.markers;
            var marker = markers_alls[i];

            //console.log('marker:', marker);

            google.maps.event.addListener(marker, 'click', function() {
                if (self.infowindow.content != undefined) {
                    self.infowindow.close();
                }
                self.infowindow = new google.maps.InfoWindow({
                    content: self.contentHTML(marker.content, marker.content.name)
                });
                //document.getElementById("storeContent").innerHTML = self.contentHTML(marker.content, marker.content.name);
                $map.setZoom(13);
                $map.setCenter(marker.getPosition());
                self.infowindow.open($map, marker);
                $map.panTo(marker.getPosition());
            });
            this.a_counter++;
            this.addMarker($map);
        } else {
            this.a_counter = 0;
        }
    }//addMarker

    contentHTML( $store, $storeName, $city, $country ) {
        const contentString = '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h2 id="firstHeading" class="firstHeading">' + $storeName + '</h2>' +
            '<div id="bodyContent">' +
            // '<p><strong>City: </strong> ' + $city + '</p>' +       
            // '<p><strong>Pais: </strong> ' + $country + '</p>' +
            ($store.address != null && $.trim($store.address) != "" ?
                '<p><strong>Dirección: </strong> ' + $store.address + '</p>' :'') +
            ($store.phone != null && $.trim($store.phone) != "" ?
                '<p><strong>Teléfono: </strong> ' + $store.phone + '</p>' :'') +
            ($store.email != null && $.trim($store.email) != "" ?
                '<p><strong>Email: </strong> ' + $store.email + '</p>' : '') +
            ($store.website != null && $.trim($store.website) != "" ?
                `<p><strong>Sitio Web: </strong> <a href="${$store.website}" target="_blank">${$store.website}</a></p>` : '') +
            ($store.schedules != null && $.trim($store.schedules) != "" ?
                '<p><strong>Horario de atención: </strong> ' + $store.schedules + '</p>' : '') +

            `<p><a href="https://www.google.com/maps/search/?api=1&query=${$store.lat}%2C${$store.lng}&zoom=11" target="_blank">Ver en Google Maps</a></p>` +
            '</div>' +
            '</div>';
        return contentString;
    }//contentHTML

    validateCountry( $callBack ){
        const self = this;
        $.ajax({
            url: `https://maps.googleapis.com/maps/api/geocode/json?libraries=places&key=${this.googleApiKey}&latlng=${this.lat_act},${this.lon_act}&sensor=false`,
            type: "GET",
            success: function(_data) {
                var name_count = _data.results[_data.results.length - 1].formatted_address.toUpperCase().split(" ").join("");
                var data_all = self.storesMapData;
                var centinela = false;
                for (name in data_all) {
                    var name_obj = name.toUpperCase().split(" ").join("");
                    if (name_obj == name_count) {
                        centinela = true;
                        self.validateCities(data_all[name], _data, $callBack);
                    }
                }
                if (centinela == false) {
                    self.loadMapDefault();
                }
            },
            error: function() {
                self.loadMapDefault();
            }
        });
    }//validateCountry

    validateCities( $data_country, $data_ajax, $callBack ){
        const data = $data_country.cities;
        const city_act = $data_ajax.results[0].formatted_address.toUpperCase().split(" ").join("");
        const centinela = false;

        for (name in data) {
            var city_obj = name.toUpperCase().split(" ").join("");
            if (city_act.indexOf(city_obj) >= 0) {
                this.createStoresMap(data[name].stores, $callBack);
                centinela = true;
            }
        }
        if (centinela == false) {
            this.createStoresMap($data_country, $callBack)
        }
    }//validateCities

    createStoresMap($stores, $callBack) {
        var stores_map = { type: 'FeatureCollection', features: [] };
        var coor_stores = [];
        if ($stores.cities != undefined) {
            $stores = $stores.cities;
            for (name_city in $stores) {
                var data_city = $stores[name_city].stores;
                //console.log(data_city);
                for (name in data_city) {
                    var data = data_city[name];
                    coor_stores.push([name, Number(data.lng), Number(data.lat), { name: name, lat: data.lat, lng: data.lng, phone: data.phone, email: data.email, address: data.address, schedules: data.schedules, website: data.website }]);
                }
            }
            this.loadList();
        } else {
            for (name in $stores) {
                var data = $stores[name];
                coor_stores.push([name, Number(data.lng), Number(data.lat), { name: name, lat: data.lat, lng: data.lng, phone: data.phone, email: data.email, address: data.address, schedules: data.schedules, website: data.website }]);
            }
        }
        $callBack(coor_stores);
    }//createStoresMap

    loadList(){
        const self = this;

        const list = document.createElement("select");
        list.id = "countries";
        list.className = "store-locator-select store-locator-select--department";
        list.setAttribute("aria-label", this.labelDepartment);
        list.onchange = function() {
            if (list.value != "NULL") {
                var list_city = document.createElement("select");
                list_city.id = "cities";
                list_city.className = "store-locator-select store-locator-select--city";
                list_city.setAttribute("aria-label", self.labelCity);
                list_city.onchange = function() {
                    self.detectedStoresPaint(self.getOption("countries").text, self.getOption("cities").text);
                };
                document.getElementById("container_city").innerHTML = "";
                document.getElementById("container_city").appendChild(list_city);
                self.fullList("city");
                self.detectedStoresPaint(self.getOption("countries").text, "");
            } else {
                document.getElementById("container_city").innerHTML = "";
            }
        };
        if (document.getElementById("countries") == null) {
            document.getElementById("container_country").appendChild(list);
        }
  
        this.fullList("country");
    }//loadList

    showError( $centinela ){
        //console.log('this.activePosition: ', this.activePosition);
        if (this.activePosition == false) {
            var obj = this.storesMapData;
            var country = this.getURLParam("pais");
            var city = this.getURLParam("tiendas");

            this.loadList();

            //console.log('country: ',country);
            //console.log('city: ',city);

            if ($centinela != true) {
                if (country == "" && city == "") {
                    if (typeof this.defaultCountry !== "undefined" && this.defaultCountry != "") {
                        $("#countries").val($("#countries option[country='" + this.defaultCountry + "'").val()).change();
                        this.detectedStoresPaint(this.defaultCountry, "");
                    }
                } else {
                    if (typeof this.defaultCountry !== "undefined" && this.defaultCountry != "") {
                        // $("#countries").val($("#countries option[country='" + this.defaultCountry + "'").val()).change();

                        // $("#cities").val($("#cities option[value='" +  this.storesInfo[this.defaultCountry].cities["Medellin"].lat + "," +  this.storesInfo[this.defaultCountry].cities["Medellin"].lng + "'").val()).change();

                        // this.detectedStoresPaint(country, "Medellin");

                        // $('.stores_ul ul li').each(function() {
                        //     console.log($(this).text())
                        //     if ($(this).text() == city) {
                        //         $(this).trigger("click");
                        //     }
                        // });
                    }
                }
            }
        }
    }//showError

    detectedStoresPaint( $country, $city ) {
        const self = this;
        const countryName = ($country && $country.text) ? $country.text : ($country || '');
        const cityName = $city || '';

        var obj = this.storesMapData;
        $country = countryName;
        $city = cityName;
        var pais = "";
        var cuidad = "";
        var options_map = { zoom: 5, mapTypeId: google.maps.MapTypeId.ROADMAP };
        var stores_arr = [];
        var centinela_global = false;
        
        //console.log('country: ',$country);
        //console.log('city: ',$city);
  
        if ($country != "" && $city == "") {
            pais = obj[$country];
            //console.log(pais);
            if (pais != undefined) {
                options_map["center"] = new google.maps.LatLng(pais.lat, pais.lng);
                var cudades = pais.cities;

                //console.log('ciudades' ,cudades);

                for (name in cudades) {
                    var stores = cudades[name].stores;

                    //console.log('stores' ,stores);

                    for (var name_store in stores) {

                        //console.log('name_store', name_store);
                        var store = stores[name_store];
                        stores_arr.push([name_store, store.lng, store.lat, { name: name_store, lat: store.lat, lng: store.lng, phone: store.phone, email: store.email, address: store.address, schedules: store.schedules, website: store.website }]);
                    }
                }
            } else {
                centinela_global = true;
                this.loadMapDefault();
            }
        }
  
        if ($country == "" && $city != "") {
            var centinela = false;
            for (name in obj) {
                var city = obj[name].cities[$city];
                if (city != undefined) {
                    centinela = true;
                    options_map.zoom = 11;
                    options_map["center"] = new google.maps.LatLng(city.lat, city.lng);
                    var stores = city.stores;
                    for (var name_store in stores) {
                        var store = stores[name_store];
                        stores_arr.push([name_store, store.lng, store.lat, { name: name_store, lat: store.lat, lng: store.lng, phone: store.phone, email: store.email, address: store.address, schedules: store.schedules, website: store.website }]);
                    }
                } else {
                    //console.log("no esta la ciudad");
                }
            }
            if (centinela == false) {
                centinela_global = true;
                this.loadMapDefault();
            }
        }
  
        if ($country == "" && $city == "") {
            centinela_global = true;
            this.loadMapDefault();
        }
  
        if ($country != "" && $city != "") {
            pais = obj[$country];
            if (pais != undefined) {
                var centinela = false;
                cuidad = pais.cities[$city];
                if (cuidad != undefined) {
                    centinela = true;
                    options_map.zoom = 11;
                    options_map["center"] = new google.maps.LatLng(cuidad.lat, cuidad.lng);
                    var stores = cuidad.stores;
                    for (var name_store in stores) {
                        var store = stores[name_store];
                        stores_arr.push([name_store, store.lng, store.lat, { name: name_store, lat: store.lat, lng: store.lng, phone: store.phone, email: store.email, address: store.address, schedules: store.schedules, website: store.website }]);
                    }
                }
                if (centinela == false) {
                    options_map["center"] = new google.maps.LatLng(pais.lat, pais.lng);
                    var cudades = pais.cities;
                    for (var name in cudades) {
                        var stores = cudades[name].stores;
                        for (var name_store in stores) {
                            var store = stores[name_store];
                            stores_arr.push([name_store, store.lng, store.lat, { name: name_store, lat: store.lat, lng: store.lng, phone: store.phone, email: store.email, address: store.address, schedules: store.schedules, website: store.website }]);
                        }
                    }
                }
  
            } else {
                var centinela = false;
                for (name in obj) {
                    var city = obj[name].cities[$city];
                    if (city != undefined) {
                        centinela = true;
                        options_map.zoom = 11;
                        options_map["center"] = new google.maps.LatLng(city.lat, city.lng);
                        var stores = city.stores;
                        for (var name_store in stores) {
                            var store = stores[name_store];
                            stores_arr.push([name_store, store.lng, store.lat, { name: name_store, lat: store.lat, lng: store.lng, phone: store.phone, email: store.email, address: store.address, schedules: store.schedules, website: store.website }]);
                        }
                    }
                }
                if (centinela == false) {
                    centinela_global = true;
                    this.loadMapDefault();
                }
            }
        }

        if (centinela_global == false) {
            var map = this.createMap(options_map);
            this.painstStores(map, stores_arr, function() {
                self.addMarker(map);
            });
        }
    }//detectedStoresPaint

    storeInMap( $position ){

        const self = this;
        //document.getElementById("storeContent").innerHTML = this.contentHTML(marker.content, marker.content.name);

        $(document).on('click', '.store-list-item', function(e){
            let positionIndex = $(e.currentTarget).attr('data-index');

            // console.log('storeInMap', self.markers);

            const marker = self.markers[positionIndex];
                marker.map.setZoom(15);
                marker.map.setCenter(marker.getPosition());
            
            console.log('marker', marker);
    
            if (self.infowindow.content != undefined) {
                self.infowindow.close();
            }
            self.infowindow = new google.maps.InfoWindow({
                content: self.contentHTML(marker.content, marker.content.name)
            });

            $(e.currentTarget).siblings().removeClass('active');
            $(e.currentTarget).toggleClass('active');
    
            self.infowindow.open(marker.map, marker);
        })     

    }//storeInMap

    loadMapDefault(){
        //console.log("Load default Map");
        var options_map = { zoom: 10, mapTypeId: google.maps.MapTypeId.ROADMAP };
        var obj = this.storesMapData;
        var ciudades = "";
        var stores_arr = [];

        options_map["center"] = new google.maps.LatLng(this.defaultLat, this.defaultLng);
        ciudades = obj[this.defaultCountry].cities;

       /*  if (!ciudades || Object.keys(ciudades).length === 0) {
            ciudades = {
                "Ciudad Default": {
                    "lat": this.defaultLat,  // Usa las coordenadas predeterminadas
                    "lng": this.defaultLng,
                    "stores": {}
                }
            };
        } */

        for (let name in ciudades) {
            var stores = ciudades[name].stores;
            for (let name_store in stores) {
                var store = stores[name_store];
                stores_arr.push([name_store, Number(store.lng), Number(store.lat), 
                    { 
                        lat: store.lat,
                        lng: store.lng,
                        name: name_store, 
                        phone: store.phone,
                        address: store.address, 
                        email: store.email, 
                        schedules: store.schedules, 
                        website: store.website
                    }
                ]);
            }
        }
        var map = this.createMap(options_map);
  
        const self = this;
        this.painstStores(map, stores_arr, function() {
            self.addMarker(map);
        });
    }//loadMapDefault

    getOption( $id ){
        let option_selected = document.getElementById($id);
            option_selected = option_selected.options[option_selected.selectedIndex];
        return option_selected;
    }//getOption

    getURLParam( $name ){
        var value = decodeURIComponent((new RegExp('[?|&]' + $name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
        if (value == null) {
            return '';
        } else {
            return value;
        }
    }//getURLParam

    fullList($list) {
        // Verifica si el argumento es "country"
        if ($list == "country") {
            // Inicializa las opciones del elemento select para países
            var options = '<option value="NULL">' + this.labelDepartment + '</option>';
            
            // Itera sobre storesMapData para construir las opciones de países
            //console.log({ fullListCountries: this.storesMapData })
            for (var name in this.storesMapData) {
                if (this.storesMapData.hasOwnProperty(name)) {
                    options += '<option country="' + name + '" value="' + 
                               String(this.storesMapData[name].lat) + ',' + 
                               String(this.storesMapData[name].lng) + '">' + 
                               name + '</option>';
                }
            }
            
            // Actualiza el HTML del elemento select con id "countries"
            var countriesElement = document.getElementById("countries");
            if (countriesElement) {
                countriesElement.innerHTML = options;
            } else {
                //console.error('Element with id "countries" not found.');
            }
    
        } else {
            // Inicializa las opciones del elemento select para ciudades
            var options = '<option value="NULL">' + this.labelCity + '</option>';
            
            // Intenta obtener el texto de la opción seleccionada en "countries"
            var countriesElement = this.getOption("countries");
            var option_selected = countriesElement ? countriesElement.text : "";
    
            // Itera sobre storesMapData para encontrar el país seleccionado
            for (var name in this.storesMapData) {
                if (this.storesMapData.hasOwnProperty(name) && option_selected === name) {
                    var city = this.storesMapData[name].cities;
                    
                    // Construye las opciones para ciudades
                    for (var name_atri in city) {
                        if (city.hasOwnProperty(name_atri)) {
                            options += '<option value="' + 
                                       String(city[name_atri].lat) + ',' + 
                                       String(city[name_atri].lng) + '">' + 
                                       name_atri + '</option>';
                        }
                    }
                    break; // Sale del bucle una vez que se encuentra el país
                }
            }
            
            // Actualiza el HTML del elemento select con id "cities"
            var citiesElement = document.getElementById("cities");
            if (citiesElement) {
                citiesElement.innerHTML = options;
            } else {
                //console.error('Element with id "cities" not found.');
            }
        }
    }
    //fullList


}

